export default {
  labels: {
    page: 'Strona {{current}} z {{total}}',
    no_file_specified: 'Nie określono pliku',
  },
  buttons: {
    previous: 'Poprzednia',
    next: 'Następna',
  },
};
